import React from 'react';
import './App.css';
import './styles/home.css';
import {QuickPrivacyModal} from "./pages/QuickPrivacy";
import {QuickStartPage, QuickStartModal} from "./pages/QuickStart";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import {Footer} from "./footer/footer";
import {Login} from "./pages/Login";
import configureStore from "./redux/store";
import {Provider} from "react-redux";
import {ProfileModalAdapter, UserContextAdapter} from "./redux/adapters/UserContextAdapter";
import {HeaderBarAdapter} from "./redux/adapters/HeaderBarAdapter";
import AccountsAdapter from "./redux/adapters/AccountsAdapter";
import { withCookies } from 'react-cookie';
import {ProfileModal} from "./pages/Profile";
import {ContactModal, ContactPage} from "./pages/Contact";
import {Institutions} from "./pages/Institutions";
import {DisclaimerPage, FullPrivacyPage, TermsOfUsePage} from "./pages/components/LegalDocuments";
import {SecurityModal, SecurityPage} from "./pages/Security";
import {Message} from "semantic-ui-react";
import {PersonalMessage} from "./pages/PersonalMessage";

const store = configureStore();

function App({ cookies }) {
    return (
        <Provider store={store}>
            <div className="App" id={"page-container"}>
                {/* load redux managed elements */}
                <div id={"body-container"}>
                    <UserContextAdapter/>
                    <HeaderBarAdapter/>
                    <ProfileModalAdapter/>

                    {/* load non-redux managed elements */}
                    <SecurityModal/>
                    <ContactModal/>
                    <QuickStartModal/>
                    <QuickPrivacyModal/>
                    <Login/>

                    <BrowserRouter>
                        <Routes>
                            {/* all elements ending in *Adapter signify Redux managed components */}

                            <Route path="/accounts" element={<AccountsAdapter cookies={cookies} />} />
                            <Route path="/quick-start" element={<QuickStartPage cookies={cookies} />} />
                            <Route path="/contact" element={<ContactPage cookies={cookies} />} />
                            <Route path="/institutions" element={<Institutions cookies={cookies} />} />
                            <Route path="/privacy" element={<FullPrivacyPage cookies={cookies} />} />
                            <Route path="/disclaimer" element={<DisclaimerPage cookies={cookies} />} />
                            <Route path="/terms" element={<TermsOfUsePage cookies={cookies} />} />
                            <Route path="/security" element={<SecurityPage cookies={cookies} />} />
                            <Route path="/personal-message" element={<PersonalMessage />} />
                            <Route path="/" element={<Home cookies={cookies} />} />
                        </Routes>
                    </BrowserRouter>
                </div>
                <Footer/>
            </div>
        </Provider>
    );
}

export default withCookies(App);